import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Logo from "../Logo";
import { useUserContext } from "../../context/userContext";

export default function SplashScreen() {
  const [fadeOut, setFadeOut] = useState(false); // Controls the fade-out effect
  const { setSplashScreen } = useUserContext();

  useEffect(() => {
    // Set timeout for starting the fade-out after the logo animation (0.3s delay + 0.3s animation)
    const fadeTimeout = setTimeout(() => {
      setFadeOut(true); // Start fading out
    }, 900); // 900ms = 0.3s delay + 0.3s animation + 0.3s delaay

    // Set timeout for hiding the splash screen after the fade-out completes
    const hideTimeout = setTimeout(() => {
      setSplashScreen(true);
    }, 1200); // 300ms fade out (1.2s total)

    return () => {
      clearTimeout(fadeTimeout);
      clearTimeout(hideTimeout);
    };
  }, []);

  const logoVariants = {
    initial: {
      marginLeft: "137.06px", // Initial position of the logo
      clipPath: "inset(0% calc(202.12px - 74px) 0% 0%)", // Initial clip path to partially hide
    },
    animate: {
      marginLeft: "0", // Slide to the left
      clipPath: "inset(0% 0% 0% 0%)", // Fully reveal the logo
      transition: {
        delay: 0.3, // Start after 0.3s
        duration: 0.3, // 0.3s duration for animation
        ease: "easeInOut",
      },
    },
  };

  return (
    <div
      className={`fixed max-w-[430px] w-screen h-screen bg-[#1E1E1E] flex justify-center items-center z-50 transition-opacity duration-300 ${
        fadeOut ? "opacity-0" : "opacity-100"
      }`}
    >
      <motion.div
        className="flex flex-col justify-center items-center overflow-hidden"
        initial="initial"
        animate="animate"
        variants={logoVariants} // Animate only the logo
      >
        <Logo fill="white" />
      </motion.div>
    </div>
  );
}
